import emptyAwardPlaceholder from "./img/prize-placeholder.webp";
import awardImage from "./img/awards/award-01.png";
import desktopDevice from "./img/desktop-device.png";
import moreAwardImage from "./img/more-soon-coupon.png";
import emptyActivityImage from "./img/activity-empty.png";
import emptyAwardImage from "./img/empty-award.jpg";
import SectionHeader from "../components/SectionHeader";
import "./style.scss";
import { useOutletContext } from "react-router-dom";
import NiceModal from "@ebay/nice-modal-react";
import listMobile from "./img/list-mobile.png";
import listDesktop from "./img/list-desktop.png";
import { getUltrainsiderActivationList } from "@api/activation";
import { getUltraInsiderPrizeList } from "@api/prize";
import { getCouponCatalogueUltraInsiderList } from "@api/coupon";
import { useQuery } from "@tanstack/react-query";
import pollPlaceholderImage from "./img/poll-placeholder.webp";
import PrizeSlider from "../components/PrizeSlider";
import AwardSlider from "../components/AwardSlider";
import BadgesSection from "../components/BadgesSection";
import EmptyListPlaceholder from "../components/EmptyListPlaceholder";
import AppPrizeSlider from "../components/AppPrizeSlider";
import couponPlaceholderImage from "./img/coupon/coupon-placeholder.jpg";
import appPlaceholderDownload from "./img/coupon/download-app-placeholder.jpg";

import {
  getBadgeStats,
  ACTIVATION_STALE_TIME,
  ACTIVATION_CACHE_TIME,
} from "@api/activation";
import { badgeCards as staticBadges } from "./data";
import { isCouponInStock } from "@app/Helpers";

import Button from "@components/Button";

const prizeCardPlaceholder = {
  uuid: "placeholder-prize",
  ident: "",
  brands: [],
  highlighted: false,
  partner: false,
  price: 0,
  level: null,
  inStock: false,
  hasPoints: false,
  hasLevel: false,

  content: {
    title:
      "<strong>Schon bald erwarten dich neue, </strong>sorgfältig kuratierte Prämien.",
  },

  hero_image: {
    file: {
      url: emptyAwardImage,
    },
    metadata: {
      imgDesc: "Willst du mehr Prämien?",
    },
  },

  thumbnail: {
    file: {
      url: emptyAwardImage,
    },
  },

  created: null,
  expiresAt: null,
  list: `
    Als Ultra Insider bekommst du:<br/>
    <strong>+5 Bonuspunkte</strong> für jede abgeschlossene Aktivität<br/>
    <strong>+2 Bonuspunkte</strong> für das Anschauen von Inspiration Stories
  `,
};

const morePrizeCardPlaceholder = {
  uuid: "more-prize-soon-placeholder",
  ident: "/coupons",
  brands: [],
  highlighted: false,
  partner: false,
  price: 0,
  level: null,
  inStock: false,
  hasPoints: false,
  hasLevel: false,
  content: {
    title: "<strong>Erhaltene Prämien </strong>im Inspiration Club",
  },
  hero_image: {
    file: {
      url: moreAwardImage,
    },
    metadata: {
      imgDesc: "Willst du mehr Prämien?",
    },
  },
  thumbnail: {
    file: {
      url: moreAwardImage,
    },
  },
  created: null,
  expiresAt: null,
  to: "/coupons/received",
  buttonCopy: "Zu meinen Prämien",
};

const appCouponPlaceholder = {
  uuid: "app-coupon-placeholder",
  ident: "app-coupon-placeholder",
  brands: [],
  highlighted: false,
  partner: false,
  price: 0,
  level: null,
  inStock: false,
  hasPoints: false,
  hasLevel: false,

  content: {
    title: "<strong>Mehr App-Gutscheine</strong> kommen bald.",
  },
  description: "Gutscheine nur in der App.",

  hero_image: {
    file: {
      url: couponPlaceholderImage,
    },
    metadata: {
      imgDesc: "Willst du mehr Prämien?",
    },
  },

  thumbnail: {
    file: {
      url: couponPlaceholderImage,
    },
  },

  created: null,
  expiresAt: null,
  list: ["Gutscheine nur in der App."],
};
const appVideoBgPlaceholder = {
  uuid: "app-video-placeholder",
  ident: "app-video-placeholder",
  video: true,
  brands: [],
  highlighted: false,
  partner: false,
  price: 0,
  level: null,
  inStock: false,
  hasPoints: false,
  hasLevel: false,

  content: {
    title: "<strong>Mehr App-Gutscheine</strong> kommen bald.",
  },
  description: "Gutscheine nur in der App.",

  hero_image: {
    file: {
      url: couponPlaceholderImage,
    },
    metadata: {
      imgDesc: "Willst du mehr Prämien?",
    },
  },

  thumbnail: {
    file: {
      url: couponPlaceholderImage,
    },
  },

  created: null,
  expiresAt: null,
  list: ["Gutscheine nur in der App."],
};

const appDownloadPlaceholder = {
  uuid: "app-download-app-placeholder",
  ident: "app-download-app-placeholder",
  brands: [],
  highlighted: false,
  partner: false,
  price: 0,
  level: null,
  inStock: true,
  hasPoints: true,
  hasLevel: true,
  appBadge: true,

  hero_image: {
    file: {
      url: appPlaceholderDownload,
    },
    metadata: {
      imgDesc: "Willst du mehr Prämien?",
    },
  },

  thumbnail: {
    file: {
      url: appPlaceholderDownload,
    },
  },

  created: null,
  expiresAt: null,
  buttonCopy: "Zu den Anweisungen",
  list: [
    "Bitte <strong>MYVUSE App</strong> installieren, anmelden und<br/> exklusive Prämien für App-Nutzer freischalten.",
  ],
};

const activityPlaceholder = {
  uuid: "placeholder-activity",
  ident: "",
  noHover: true,
  brands: [],
  highlighted: false,
  partner: false,
  price: 0,
  level: null,
  inStock: false,
  hasPoints: false,
  hasLevel: false,

  content: {
    title:
      "<strong>Bald verfügbar:</strong> exklusive Möglichkeiten, noch mehr Punkte zu sammeln.",
  },

  hero_image: {
    file: {
      url: emptyActivityImage,
    },
    metadata: {
      imgDesc: "Willst du mehr Prämien?",
    },
  },

  thumbnail: {
    file: {
      url: emptyActivityImage,
    },
  },

  created: null,
  expiresAt: null,
  list: [
    "<strong>+5 Bonuspunkte </strong> für jede abgeschlossene Aktivität",
    "<strong>+2 Bonuspunkte </strong>  für das Anschauen von Inspiration Stories",
  ],
  withButton: true,
  buttonCopy: "MACH DICH BEREIT!",
  nonClickable: true,
};

export default function Benefits() {
  const ultraInsider = useOutletContext();

  const { data: prizes, isLoading } = useQuery({
    queryKey: ["prize-ultra-insider"],
    queryFn: () =>
      getUltraInsiderPrizeList({
        device: ["web"],
        target: ["web"],
      }),
    suspense: false,
    enabled: ultraInsider,
  });

  console.log("prizes", prizes);

  const mappedPrizes = prizes?.prizes?.map((prize, index) => {
    const catalogue = prize.catalogue;

    return {
      brands: catalogue?.brands || ["vuse"],
      content: {
        title: catalogue?.content?.title || "",
        description: catalogue?.content?.description || "",
      },
      thumbnail: {
        file: {
          url: catalogue?.thumbnail?.file?.url || emptyAwardPlaceholder,
        },
        metadata: catalogue?.thumbnail?.metadata || {},
        position: catalogue?.thumbnail?.position ?? 0,
        type: catalogue?.thumbnail?.type || "thumbnail",
      },
      hero_image: {
        file: {
          url: catalogue?.hero_image?.file?.url || awardImage,
        },
        columns: catalogue?.hero_image?.columns || null,
        custom: catalogue?.hero_image?.custom || null,
        metadata: catalogue?.hero_image?.metadata || {},
        position: catalogue?.hero_image?.position ?? 0,
        type: catalogue?.hero_image?.type || "hero_image",
      },
      highlighted: catalogue?.highlighted ?? false,
      price: catalogue?.price ?? 0,
      hasLevel: catalogue?.hasLevel ?? true,
      hasPoints: catalogue?.hasPoints ?? true,
      inStock: catalogue?.inStock ?? true,
      partner: catalogue?.partner ?? false,
      ident: catalogue?.ident || prize.uuid,
      level: catalogue?.level ?? "",
      uuid: prize.uuid,
      created: prize.created,
      expiresAt: prize.expiresAt,
    };
  });

  console.log("mappedPrizes", mappedPrizes);

  const prizesToReedem = (mappedPrizes || []).filter(
    (prize) =>
      prize.hasLevel &&
      prize.hasPoints &&
      prize.inStock &&
      prize.completed !== true,
  );

  console.log("prizesToReedem", prizesToReedem);

  const coupons = useQuery({
    queryKey: ["coupon-ultra-insider"],
    queryFn: () =>
      getCouponCatalogueUltraInsiderList({
        device: ["web"],
        target: ["web"],
      }),
    suspense: false,
    enabled: ultraInsider,
  });

  const mappedCoupons = coupons?.data?.catalogue?.map((e) => {
    return {
      brands: e?.brands || ["vuse"],
      content: {
        title: e?.content?.title || "",
        description: e?.content?.description || "",
      },
      thumbnail: {
        file: {
          url: e?.thumbnail?.file?.url || emptyAwardPlaceholder,
        },
        metadata: e?.thumbnail?.metadata || {},
        position: e?.thumbnail?.position ?? 0,
        type: e?.thumbnail?.type || "thumbnail",
      },
      hero_image: {
        file: {
          url: e?.hero_image?.file?.url || awardImage,
        },
        columns: e?.hero_image?.columns || null,
        custom: e?.hero_image?.custom || null,
        metadata: e?.hero_image?.metadata || {},
        position: e?.hero_image?.position ?? 0,
        type: e?.hero_image?.type || "hero_image",
      },
      highlighted: e?.highlighted ?? false,
      price: e?.price ?? 0,
      hasLevel: e?.hasLevel ?? true,
      hasPoints: e?.hasPoints ?? true,
      inStock: isCouponInStock(e),
      partner: e?.partner ?? false,
      ident: e?.ident,
      level: e?.level ?? "",
      activation: e?.activation,
      availabilityLevel: e?.availabilityLevel ?? null,
    };
  });

  const couponsToRedeem = (mappedCoupons || []).filter(
    (coupon) =>
      coupon.hasLevel &&
      coupon.hasPoints &&
      isCouponInStock(coupon) &&
      coupon.completed !== true,
  );

  const applicationCoupons = useQuery({
    queryKey: ["coupon-ultra-insider-android"],
    queryFn: () =>
      getCouponCatalogueUltraInsiderList({
        limit: 100,
        offset: 0,
        device: ["web"],
        target: ["android", "ios"],
      }),
    suspense: false,
    enabled: ultraInsider,
  });

  const mapAppCoupons = (catalogue) =>
    (catalogue || []).map((e) => ({
      brands: e?.brands || ["vuse"],
      content: {
        title: e?.content?.title || "",
        description: e?.content?.description || "",
      },
      thumbnail: {
        file: {
          url: e?.thumbnail?.file?.url || emptyAwardPlaceholder,
        },
        metadata: e?.thumbnail?.metadata || {},
        position: e?.thumbnail?.position ?? 0,
        type: e?.thumbnail?.type || "thumbnail",
      },
      hero_image: {
        file: {
          url: e?.hero_image?.file?.url || awardImage,
        },
        columns: e?.hero_image?.columns || null,
        custom: e?.hero_image?.custom || null,
        metadata: e?.hero_image?.metadata || {},
        position: e?.hero_image?.position ?? 0,
        type: e?.hero_image?.type || "hero_image",
      },
      highlighted: e?.highlighted ?? false,
      price: e?.price ?? 0,
      hasLevel: e?.hasLevel ?? true,
      hasPoints: e?.hasPoints ?? true,
      inStock: isCouponInStock(e),
      partner: e?.partner ?? false,
      ident: e?.ident,
      level: e?.level ?? "",
      activation: e?.activation,
      availabilityLevel: e?.availabilityLevel ?? null,
      ultraInsiderRedemption: e?.ultraInsiderRedemption || [],
      appBadge: true,
    }));

  const mappedApplicationCoupons = mapAppCoupons(
    applicationCoupons?.data?.catalogue,
  );

  const appCouponsWithPlaceholders = [
    appDownloadPlaceholder,
    ...mappedApplicationCoupons,
    appCouponPlaceholder,
    appVideoBgPlaceholder,
  ];

  const combinedItems = [...(prizesToReedem || []), ...(couponsToRedeem || [])];
  const prizesToRender =
    combinedItems.length > 0
      ? [
          ...combinedItems,
          morePrizeCardPlaceholder,
          prizeCardPlaceholder,
          appVideoBgPlaceholder,
        ]
      : [];

  console.log("prizesToRender", prizesToRender);

  const { data } = useQuery({
    queryKey: ["badge-stats-ultra-insider"],
    queryFn: () => getBadgeStats({}),
    staleTime: ACTIVATION_STALE_TIME,
    cacheTime: ACTIVATION_CACHE_TIME,
    refetchOnMount: "always",
    suspense: false,
    enabled: ultraInsider,
  });

  const userBadgeState = data?.passport?.badge;
  const pollDate = data?.passport?.poll_allowed;

  const pollDateFormattedDE = pollDate
    ? new Date(pollDate).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    : null;

  const badges = userBadgeState
    ? staticBadges
        .map((card) => {
          const state = userBadgeState[card.ident];
          const completed = state !== null;
          return {
            ...card,
            completed,
            unlockedAt: completed ? state : undefined,
          };
        })
        .sort((a, b) => {
          if (a.completed === b.completed) return 0;
          return a.completed ? -1 : 1;
        })
    : [];

  const activationData = useQuery({
    queryKey: ["activation-ultra-insider"],
    queryFn: () => getUltrainsiderActivationList(),
    suspense: false,
    enabled: ultraInsider,
  });

  const pollPlaceholder = {
    thumbnail: {
      file: {
        url: pollPlaceholderImage,
      },
    },
    hero_image: {
      file: {
        url: pollPlaceholderImage,
      },
      metadata: {
        imgDesc: "Umfrage",
      },
    },
    content: {
      title: "<strong>Umfrage – Inspiration Club</strong>",
      description: "<span>100% Rabatt auf 1 Packung Pods</span>",
    },
    brands: ["vuse"],
    completed: false,
    ident: "poll-placeholder",
    type: "ultra-insider-poll",
    disabled: true,
    date: pollDateFormattedDE ? pollDateFormattedDE : "",
  };

  const baseActivationList =
    activationData?.data?.activations?.filter(
      (item) => !item.completed || item.expired,
    ) ?? [];

  const isPollAvailable =
    data?.passport?.poll_allowed &&
    baseActivationList?.includes(
      (item) => item?.ident === "ultrainsider_poll_2025",
    )
      ? new Date(data.passport.poll_allowed) <= new Date()
      : false;

  const filteredActivationList = isPollAvailable
    ? baseActivationList
    : baseActivationList?.filter(
        (item) => item?.ident !== "ultrainsider_poll_2025",
      );

  const activationListWithPoll = isPollAvailable
    ? [
        ...filteredActivationList,
        activityPlaceholder,
        pollPlaceholder,
        appVideoBgPlaceholder,
      ]
    : [...filteredActivationList, activityPlaceholder, appVideoBgPlaceholder];

  if (ultraInsider === undefined) {
    return null;
  }

  return (
    <div className={`ultra-insider-page `}>
      {ultraInsider ? (
        <div className="insider-status-benefits">
          <div className="intro">
            <div className="content">
              <p className="title">Ultra Insider</p>
              <p className="desc">
                Mit dem <strong>Ultra Insider Status</strong> hast du Zugang
                zu neuen Vorzügen, darunter:
              </p>
              <picture>
                <source media="(min-width: 768px)" srcSet={listDesktop} />
                <img src={listMobile} alt="List" className="list" />
              </picture>
            </div>
            <div className="image-device">
              <img src={desktopDevice} alt="Device" />
            </div>
          </div>
          <div className="bottom-cards">
            <SectionHeader>
              <span>Hochwertige</span>
              <strong> Prämien</strong>
            </SectionHeader>
            {isLoading ? (
              <div className="loading-container">
                <div className="spinner"></div>
              </div>
            ) : (
              <>
                {prizesToRender?.length > 2 ? (
                  <PrizeSlider prizesToRender={prizesToRender} />
                ) : (
                  <EmptyListPlaceholder>
                    <>
                      <>
                        {" "}
                        <h2>
                          Schon bald erwarten dich neue,
                          <br className="only-mobile" />
                          <span> sorgfältig kuratierte&nbsp;Prämien.</span>
                        </h2>
                        <div className="divider"></div>
                        <p className="subtitle">
                          Als Ultra Insider bekommst du:
                        </p>
                        <ul>
                          <li>
                            <strong>+5 Bonuspunkte</strong> für jede
                            abgeschlossene Aktivität
                          </li>
                          <li>
                            <strong>+2 Bonuspunkte</strong> für das Anschauen
                            von Inspiration Stories
                          </li>
                        </ul>
                      </>
                    </>
                  </EmptyListPlaceholder>
                )}
              </>
            )}
          </div>

          <div className="activities-section">
            <SectionHeader>
              <span>Zusätzliche</span>
              <strong> Aktivitäten</strong>
            </SectionHeader>

            <div className="activities-wrapper">
              {activationListWithPoll?.length > 2 ? (
                <AwardSlider awardsToRender={activationListWithPoll} />
              ) : (
                <EmptyListPlaceholder>
                  <>
                    <h2>
                      Bald verfügbar:
                      <br />
                      <span>
                        exklusive Möglichkeiten, noch mehr Punkte zu sammeln.
                      </span>
                    </h2>
                    <div className="divider"></div>

                    <button className="cta">mach dich bereit!</button>
                  </>
                </EmptyListPlaceholder>
              )}
            </div>
          </div>

          <div className="app-prize-wrapper">
            <SectionHeader>
              <span>Prämien nur für</span>
              <strong> App-Nutzer</strong>
            </SectionHeader>
            <AppPrizeSlider prizesToRender={appCouponsWithPlaceholders} />
          </div>
          <BadgesSection badges={badges} />
        </div>
      ) : (
        <div className="insider-hero-no-status">
          <div className="intro">
            <div className="content">
              <h1 className="title">Werde Ultra Insider</h1>
              <p className="desc">
                Mit dem <strong>Ultra Insider Status</strong> hast du Zugang
                zu neuen Vorzügen, darunter:
              </p>
              <picture>
                <source media="(min-width: 768px)" srcSet={listDesktop} />
                <img src={listMobile} alt="List" className="list" />
              </picture>
              <Button
                action={() => {
                  NiceModal.show("connect-modal", {});
                }}
                btnClass="ultra-insider"
              >
                Jetzt registrieren
              </Button>
            </div>
            <div className="image-device">
              <img src={desktopDevice} alt="Device" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
